export default __webpack_public_path__ + "static/media/24H_Blue.f9ecf318.png";